import { Directive, HostBinding, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { FormStatus, FormStatusService } from './form-status.service';

@Directive({ selector: 'input, textarea' })
export class InputFormStatusDirective implements OnDestroy {
  constructor(private readonly formStatus: FormStatusService) {
    this.setStatus.pipe(takeUntil(this.destroy)).subscribe();
  }

  private readonly destroy = new Subject();

  private readonly setStatus = this.formStatus.value.pipe(
    tap(value => {
      this.status = value;
    }),
  );

  private status: FormStatus = FormStatus.EDIT;

  @Input('disabled')
  disabledOverride: boolean;

  @Input('readonly')
  readonlyOverride: boolean;

  @HostBinding('readonly')
  get readonly() {
    if (this.readonlyOverride != null) {
      return this.readonlyOverride;
    }
    return this.status === FormStatus.READONLY;
  }

  @HostBinding('disabled')
  get disabled() {
    if (this.disabledOverride != null) {
      return this.disabledOverride;
    }
    return this.status === FormStatus.DISABLED;
  }

  ngOnDestroy() {
    this.destroy.next(undefined);
  }
}
